import React, { useContext } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import MaestroNavbar from "./blocks/MaestroNavbar.js";
import MaestroFooter from "./blocks/MaestroFooter.js";
import Seo from "./blocks/Seo.js";
import { AuthContext } from "src/utils/AuthContext.js";
import { getPageRoute } from "src/services";
import HomeHero from "./home/HomeHero.js";
import HowItWorks from "./home/HowItWorks.js";
import DataProblem from "./home/DataProblem.js";
import WhatsDifferent from "./home/WhatsDifferent.js";
import WhereWereLive from "./home/WhereWereLive.js";
import Values from "./home/Values.js";
import TeacherToCoach from "./home/TeacherToCoach.js";
import Stories from "./home/Stories.js";
import Pricing from "./home/Pricing.js";
import Waitlist from "./home/Waitlist.js";
// MediaVoices intentionally not mounted for launch. See PR discussion.
// import MediaVoices from "./home/MediaVoices.js";

const Home = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  React.useEffect(() => {
    if (user) {
      navigate(getPageRoute("maestro", "DASHBOARD"));
    }
  }, [user, navigate]);

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: theme.palette.paper.primary,
        minHeight: "100vh",
      }}
    >
      <Seo
        title="Maestro — AI + coaching for K-12 STEM teachers"
        description="Maestro pairs every K-12 STEM teacher with a personalized AI workflow and a weekly coach. Every classroom in year one beat the national growth norm by 200-400%."
      />

      <MaestroNavbar />

      <HomeHero />
      <HowItWorks />
      <DataProblem />
      <WhatsDifferent />
      <Stories />
      <Values />
      <TeacherToCoach />
      <WhereWereLive />
      <Pricing />
      <Waitlist />
      <MaestroFooter />
    </Box>
  );
};

export default Home;
